module.exports = __webpack_public_path__ + "static/media/profile_risk.97e59e39.svg";